// extracted by mini-css-extract-plugin
export var aboutPageBg = "aboutPage-module--about-page-bg--td7oY";
export var aboutPageContainer = "aboutPage-module--about-page-container--g5sYz";
export var contactButton = "aboutPage-module--contact-button--AJ983";